<template>
  <div class="payment-detail-page">
    <!-- <Header /> -->
    <div>
      <h2>Payment detail</h2>
      <v-card
      >
        <v-list-item>
          <v-list-item-content>
            <div class="text-overline Monthlybox">
              Subscription Plan - {{pricingListName+' '}}

            </div>
           <div class="amount-list">
              <ul>
                <li v-if="monthly == 'yearly'"><strong>Total Amount</strong></li>
                <li v-else><strong>Total Amount</strong></li>
                <li><span class="rupee-sign"></span>&nbsp;{{amount}} INR (₹)</li>
              </ul>
           </div>
          </v-list-item-content>
        </v-list-item> 
        <v-list-item>
          <v-list-item-content>
            <!-- <p></p> -->
            <p><b>Note:</b> We will charge INR <b>{{amount}}/yearly</b> after 60 days of purchasing subscription.</p>
            <p>You will receive 99 reward points worth Rs 99 on successful payment.</p>
            <p>You can also refer and earn 100 reward points worth Rs 100.</p>
            <p>T&C apply</p>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-btn
            class="blue-btn btn"
            @click="proceed"
          >
            Proceed
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
  import { Auth } from 'aws-amplify';
  import Header from '../common/Header.vue';
  import { CREATE_USER_PLAN_SUBSCRIPTION, VERIFY_RAZORPAY_SIGNATURE, UPDATE_PROFILE_DETAIL } from "../../store/actions.type";
  import JwtService from ".././common/jwt.service";
  export default {
    components: {Header},
    data: () => ({
      pricingListName:atob(JwtService.getPricingListName()),
      monthly:atob(JwtService.getMonthly()),
      amount:atob(JwtService.getAmount()),
      currency:atob(JwtService.getCurrency()),
      plan_id:atob(JwtService.getPlan()),
      name:'',
      email:'',
      mobile_no:'',
      plan_type:'',
      subscription_id:'',
      customer_id:'',
    }),
    created() {
      Auth.currentAuthenticatedUser({
        bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        }).then((user) => {
          this.name  = user.attributes['custom:name'];
          this.email = user.attributes['email'];
          this.mobile_no = user.attributes['custom:phonenumber'];
        })
        .catch(err => {
          this.$router.push({ name: 'Login' }).catch(()=>{});
        });
      },
    methods: {
      proceed() {
        this.$loading(true)
        this.$store.dispatch(CREATE_USER_PLAN_SUBSCRIPTION, {
          data: {
            name:this.name,
            email:this.email,
            mobile_no:this.mobile_no,
            amount:this.amount * 100,
            currency:this.currency,
            aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
            plan_id:this.plan_id,
            plan_type:this.monthly,
          },
          api: "create-user-plan-subscription"
        })
        .then(() =>  {
          this.subscription_id = this.$store.getters.getUserPlanSubscription.data.subscription_id;
          var options = {
            "key": "rzp_test_AdFDgVWagtsr6M",
            "amount": this.amount * 100,
            "currency": "INR",
            "subscription_id": this.subscription_id,
            "name": this.name,
            "description": this.pricingListName + '('+this.monthly.charAt(0).toUpperCase() + this.monthly.slice(1)+' Plan)',
            "image": "",
            "handler": (response) =>  {
              this.$loading(true)
              this.$store.dispatch(VERIFY_RAZORPAY_SIGNATURE, {
                data: {
                  aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
                  razorpay_payment_id:response.razorpay_payment_id,
                  razorpay_subscription_id:response.razorpay_subscription_id,
                  razorpay_signature:response.razorpay_signature,
                  plan_id:this.plan_id,
                  name:this.name,
                  email:this.email,
                },
                api: "verify-razorpay-signature"
              })
              .then(() =>  {
                let updatedDetail = [
                  {key:'is_plan_active', value:this.$store.getters.getVerifyRazorpaySignature.data.is_plan_active},
                  {key:'subscription_plans', value:this.$store.getters.getVerifyRazorpaySignature.data.subscription_plans},
                  {key:'show_add_family_member_button', value:this.$store.getters.getVerifyRazorpaySignature.show_add_family_member_button}
                ]
                this.$store.dispatch(UPDATE_PROFILE_DETAIL,updatedDetail)
                this.$router.push({ name: 'SubscriptionCongratulations' }).catch(()=>{})
                this.$loading(false);
              })
              .catch((error) =>  {
                this.$loading(false)
              });

            },
            "prefill": {"name": this.name,"email": this.email,"contact": this.mobile_no},
            "notes": {"note_key_1": "Tea. Earl Grey. Hot","note_key_2": "Make it so."},
            "theme": {"color": "#3399cc"}
          };
          var rzp1 = new Razorpay(options);
          rzp1.on('payment.failed', function (response){
            this.$loading(false)
          });
          rzp1.open().then((response) => {
            this.$loading(false);
          });
        })
        .catch((error) => {
          this.$loading(false);
        });
      },
      chooseOption(){
        this.$router.push({ name: 'ChooseOption' }).catch(()=>{});
      }
    }
  }
</script>